'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Img_Img = require('../Img/Img.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const avatar = "_avatar_13ug1_1";
const img = "_img_13ug1_55";
const styles = {
	avatar: avatar,
	img: img
};

const getNameInitials = (name) => {
  const initials = (name || "").trim().split(/\s+/).map((s) => s[0]);
  const firstLetter = initials[0];
  const lastLetter = initials[initials.length - 1];
  if (!firstLetter) {
    return "";
  }
  return initials.length === 1 ? String(firstLetter) : `${firstLetter}${lastLetter}`;
};
const SIZES = {
  small: 24,
  medium: 36,
  large: 48
};
const Avatar = ({ "aria-hidden": ariaHidden, color, isBlock, isInteractive, isSelected, name, url, shouldLazilyLoad = true, size = "small" }) => {
  const [hasError, setHasError] = React.useState(false);
  const initials = name ? getNameInitials(name) : null;
  React.useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [url]);
  const showInitials = !url || url && hasError;
  return React__default.default.createElement("div", { "aria-hidden": ariaHidden, "aria-label": name, className: styles.avatar, "data-block": isBlock ? "true" : void 0, "data-color": color, "data-show-initials": showInitials, "data-interactive": isInteractive ? "true" : void 0, "data-selected": isSelected ? "true" : void 0, "data-size": size, "data-testid": "Avatar", "data-zds": true, role: "img" }, url && !hasError ? React__default.default.createElement(components_display_Img_Img.Img, { className: styles.img, alt: name, "aria-hidden": true, height: SIZES[size], onError: () => setHasError(true), src: url, width: SIZES[size], loading: shouldLazilyLoad ? "lazy" : "eager" }) : React__default.default.createElement("span", null, initials));
};

exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.cjs.js.map
